import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';

function Contact() {
    return (<>
            <Navbar></Navbar>
            <ContactForm></ContactForm>
            <Footer></Footer>
    </>
    );
}

export default Contact;
